import { Button, Paper, Grid, TextField, FormControl, InputLabel, Select, Chip } from "@material-ui/core";
import * as React from "react";
import { observable, toJS, action } from "mobx";
import { createStyles, withStyles, WithStyles } from "@material-ui/core/styles";
import { history } from "src/history.js";
import { authStore } from "src/modules/auth";
import { observer } from 'mobx-react';
import { config } from "src/config";
import { withRouter } from 'react-router';
import { DevDashboard } from './';
import { AdminDashboard } from './';
import { CompanyAdminDashboard } from './';
import { SiteAdminDashboard } from './';
import { ManagerDashboard } from './';
import { PortalUserDashboard } from './';

const styles = createStyles({
  root: {
    padding: "2rem",
  },
  buttonDiv: {
    marginTop: "1rem",
    justifyContent: "center",
    display: "flex",
  },
  button: {
    height: "128px",
    width: "128px",
    marginRight: "24px",
    marginBottom: "24px",
    border: "1px solid #1f1d1d",
    color: "#efefef",
    borderRadius: "64px",
  }
});

@observer
class Dashboard extends React.Component<any> {

  constructor(props: any) {
    super(props);
  }

  public render() {
    const { classes } = this.props;
    const user_role = authStore.currentUser.ViewingRole;

    switch (user_role) {
      case (1): {
        return (<DevDashboard />)
      }
      case (2): {
        return (<AdminDashboard />)
      }
      case (3): {
        return (<CompanyAdminDashboard />)
      }
      case (4): {
        return (<SiteAdminDashboard />)
      }
      case (5): {
        return (<PortalUserDashboard />)
      }
      case (6): {
        return (<ManagerDashboard />)
      }
      case (7): {
        return (<ManagerDashboard />) //D-011
      }
      case (8): {
        return (<ManagerDashboard />) // D-011
      }
      default: {
        return (<div>Dash placeholder</div>)
      }
    }
  }

}

export default withStyles(styles, { withTheme: true })(
  withRouter(Dashboard)
);


// WEBPACK FOOTER //
// ./src/modules/dashboard/Dashboard.tsx